import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBag"><Path fillRule="evenodd" clipRule="evenodd" d="M7.00238 3V7H2L2.00091 12H22.0002V14H13.0024V16H11.0024V14H2.00127L2.00254 21H22.0024L21.9997 7H17.0024V3H7.00238ZM15.0024 7V5H9.00238V7H15.0024Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag;
